import { firebase } from '../../firebase'
import undefinedToDeletes from './internal'

export default undefinedToDeletes(firebase)



// WEBPACK FOOTER //
// ./src/utilities/Data/undefinedToDeletes/index.js